import { render, staticRenderFns } from "./ReceiveModal.vue?vue&type=template&id=d57b7ade&scoped=true"
import script from "./ReceiveModal.vue?vue&type=script&lang=js"
export * from "./ReceiveModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiveModal.vue?vue&type=style&index=0&id=d57b7ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57b7ade",
  null
  
)

export default component.exports